import { datadogRum } from '@datadog/browser-rum'

export default {
  rum: {
    async init() {
      try {
        datadogRum.init({
          applicationId: '772777b9-2a4e-4b7f-955a-ac43674c919f',
          clientToken: 'pubadf53b4bddea411d58f0337a6bf02027',
          service: 'default',
          site: 'datadoghq.eu',
          env: process.env.REACT_APP_ENV,
          version: process.env.REACT_APP_VERSION,
          sessionSampleRate: 100,
          sessionReplaySampleRate: 20,
          defaultPrivacyLevel: 'mask-user-input'
        })

        console.log(
          `Datadog service - frontend ${process.env.REACT_APP_VERSION} ${process.env.REACT_APP_ENV} RUM initialised!`
        )
      } catch (err) {
        console.error(`Datadog service - ${err.message}`)
      }
    }
  }
}
